import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

import classNames from '@utils/classnames';
import { useTranslation } from '../../contexts/translation-context';
import { Button } from '../button/Button';

export interface IPaginationProps {
  hasPrevious: boolean;
  previous: () => void;
  hasNext: boolean;
  next: () => void;
  isFetching: boolean;
  /** Optional summary shown left of the buttons, e.g. "5 van 128 orders". */
  summary?: React.ReactNode;
  className?: string;
}

/** Vorige / Volgende as a compact button pair, right-aligned; optional summary on the left. */
export const Pagination: React.FC<IPaginationProps> = (props) => {
  const { hasPrevious, previous, hasNext, next, isFetching, summary, className } = props;
  const { i18n } = useTranslation();

  return (
    <div className={classNames('flex items-center justify-between gap-4', className)}>
      <div className="min-w-0 text-xs text-fg-muted">{summary}</div>
      <div className="flex shrink-0 items-center gap-2">
        <Button
          size={8}
          color="secondary"
          iconLeft={<CaretLeftIcon className="button-icon" weight="bold" />}
          isDisabled={isFetching || !hasPrevious}
          onTrigger={previous}
          isLoading={isFetching}
        >
          {i18n('previous')}
        </Button>
        <Button
          size={8}
          color="secondary"
          iconRight={<CaretRightIcon className="button-icon" weight="bold" />}
          isDisabled={isFetching || !hasNext}
          onTrigger={next}
          isLoading={isFetching}
        >
          {i18n('next')}
        </Button>
      </div>
    </div>
  );
};
